import { useMutation, useQueryClient } from '@tanstack/react-query';
import React from 'react';
import { Button, Message } from 'ui';
import { unreportItem } from '~/api/item';
import ReportIcon from '~/public/static/svg/ReportIcon';

interface Props {
  itemId: number;
}

const UnreportButton: React.FC<Props> = ({ itemId }) => {
  const queryClient = useQueryClient();
  const { isLoading, isSuccess, mutate } = useMutation(
    () => unreportItem(itemId),
    {
      onSuccess: () => queryClient.invalidateQueries([itemId]),
    },
  );

  return (
    <div className="w-full">
      <Button
        className="flex h-10 w-full flex-1 items-center justify-center"
        onClick={() => mutate()}
        disabled={isLoading}
        variant="outlined"
        color="grey"
      >
        <ReportIcon className="mr-1" /> Unreport
      </Button>

      {isSuccess && (
        <Message success className="mt-2">
          Unreported
        </Message>
      )}
    </div>
  );
};

export default UnreportButton;
